import axios from "axios";

import { Listing, Service } from "../types";
import serialiseService from "./serialiseService";

async function searchById(id: string): Promise<Listing> {
  const response = await axios
    .get<Service>(
      `https://api.nhsd.healthdirect.org.au/v5/healthcareServices/${id}`,
      {
        headers: {
          "x-api-key": "9zNfxJzo2S90RMm2UIBFj4mZe3Fc3m6w6QsgAEoP",
        },
      }
    )
    .then((response) => {
      return serialiseService(response.data);
    });

  return response;
}

export default searchById;
